module.exports = __webpack_public_path__ + "assets/images/banner/hero-banner.jpg?v=bfb47fea";